'use strict';

import moment from 'moment';
import dataHandler from './../data-handler';
import vaccinesAgeTotal from './vaccines-age-total';
import vaccinesAgePerWeek from './vaccine-age-per-week';

const vaccineCharts = (function() {

    function setVaccineFirstWeek(data) {
        moment.locale('fi');

        const weekArr = data.vaccines.doses[0].weeks[0].week.split('_');
        const dataFirstDate = moment().year(weekArr[0]).day(1).week(weekArr[1]);
        dataFirstDate.set({
            hour: 0,
            minute: 0,
            second: 0
        });

        window.config.firstDayValues.vaccineWeeks = dataHandler.getChartFirstDate(dataFirstDate);
    }

    function init(data) {
        if (typeof data.vaccines !== 'undefined' && typeof data.vaccines.doses !== 'undefined' && data.vaccines.doses.length) {
            // Init vaccine charts
            setVaccineFirstWeek(data);

            vaccinesAgeTotal.init(data);
            vaccinesAgePerWeek.init(data);
        }
    }

    function reload(data, page) {
        const reloadCharts = [];

        // Date change
        if (page.classList.contains('reload-date')) {
            setVaccineFirstWeek(data);

            if (reloadCharts.indexOf('vaccinesAgePerWeek') === -1) {
                reloadCharts.push('vaccinesAgePerWeek');
            }
            page.classList.remove('reload-date');
        }

        // Reload charts
        for (let chartType of reloadCharts) {
            if (chartType === 'vaccinesAgePerWeek') {
                vaccinesAgePerWeek.reload(data);
            }
        }

        page.classList.remove('reload');
    }

    return {
        init,
        reload
    }
})();

export default vaccineCharts;
